import { Card, CardBody, CardFooter, CardHeader } from '@heroui/react';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/checkout-success')({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <Card className='m-4 mx-auto max-w-xl p-4'>
            <CardHeader className=' text-2xl font-bold'>Thank you for your purchase!</CardHeader>
            <CardBody className=' text-lg'>
                You will receive an email with your login details. Check your spam folder if you don't see it.
            </CardBody>
            <CardFooter className=' text-lg'>
                <div>
                    Contact{' '}
                    <a href='mailto:chandler@caddystats.golf' className='font-semibold text-green-500'>
                        chandler@caddystats.golf
                    </a>{' '}
                    for support if you have any issues.
                </div>
            </CardFooter>
        </Card>
    );
}
